import React, { useState } from 'react'
import cx from 'classnames'
import { Icon } from '@components/UI'

import Actions from './Actions'
import Details from './Details'
import About from './About'

const Header = ({ file, back, close, exportConfig, exportToSketch }) => {
  const [isExpanded, setIsExpanded] = useState(true)

  return (
    <div className={cx('gp-preview-header', { 'is-expanded': isExpanded })}>
      {!!back && (
        <div className='gp-preview-header-backButton control-container dark'>
          <button onClick={back}>
            <Icon name='arrow left long' />
          </button>
        </div>
      )}

      <div className='gp-preview-header-main'>
        <About file={file} showDescription={isExpanded} />
        {isExpanded && <Details file={file} />}
      </div>
      <Actions
        close={close}
        exportConfig={exportConfig}
        exportToSketch={exportToSketch}
        file={file}
        expanded={isExpanded}
        expand={(value) => setIsExpanded(value)}
      />
    </div>
  )
}

export default Header
